import { render } from "./GalleryCard.vue?vue&type=template&id=ca275232&scoped=true"
import script from "./GalleryCard.vue?vue&type=script&lang=js"
export * from "./GalleryCard.vue?vue&type=script&lang=js"

import "./GalleryCard.vue?vue&type=style&index=0&id=ca275232&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ca275232"

export default script